import api from '../../../App/socket';

export const getUsersList = (searchText = '') => api.send({
    api: 'db',
    model: 'User',
    action: 'Read',
    options: {
        limit: 10,
        attributes: ['ref_user_status', 'person.first_name', 'person.last_name'],
        where:
                {
                    $or:
                        [
                            {
                                'person.first_name':
                                    {
                                        $regex: searchText,
                                        $options: 'i',
                                    },
                            },
                            {
                                'person.last_name':
                                    {
                                        $regex: searchText,
                                        $options: 'i',
                                    },
                            },
                        ],

                },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/get_users_list_request.js